var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentText({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.5 10.1901H17.61C15.24 10.1901 13.31 8.26006 13.31 5.89006V3.00006C13.31 2.45006 12.86 2.00006 12.31 2.00006H8.07C4.99 2.00006 2.5 4.00006 2.5 7.57006V16.4301C2.5 20.0001 4.99 22.0001 8.07 22.0001H15.93C19.01 22.0001 21.5 20.0001 21.5 16.4301V11.1901C21.5 10.6401 21.05 10.1901 20.5 10.1901Z",
    fill: "#2C53F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7997 2.21005C15.3897 1.80005 14.6797 2.08005 14.6797 2.65005V6.14005C14.6797 7.60005 15.9197 8.81005 17.4297 8.81005C18.3797 8.82005 19.6997 8.82005 20.8297 8.82005C21.3997 8.82005 21.6997 8.15005 21.2997 7.75005C19.8597 6.30005 17.2797 3.69005 15.7997 2.21005Z",
    fill: "#2C53F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13.7501H7.5C7.09 13.7501 6.75 13.4101 6.75 13.0001C6.75 12.5901 7.09 12.2501 7.5 12.2501H13.5C13.91 12.2501 14.25 12.5901 14.25 13.0001C14.25 13.4101 13.91 13.7501 13.5 13.7501Z",
    fill: "#2C53F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 17.7501H7.5C7.09 17.7501 6.75 17.4101 6.75 17.0001C6.75 16.5901 7.09 16.2501 7.5 16.2501H11.5C11.91 16.2501 12.25 16.5901 12.25 17.0001C12.25 17.4101 11.91 17.7501 11.5 17.7501Z",
    fill: "#2C53F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentText);
export default __webpack_public_path__ + "static/media/document-text.c793657bd1c4339655fbad0a5201b541.svg";
export { ForwardRef as ReactComponent };